import clsx from 'clsx'
import React from 'react'

import { ROW_BG_CLASSES, ROW_BORDER_CLASSES, ROW_FOCUS_CLASSES } from './constants'

interface TableActionsCellProps extends Omit<React.TdHTMLAttributes<HTMLTableCellElement>, 'className'> {
  children: React.ReactNode;
  alwaysVisible?: boolean;
}

export function TableActionsCell ({ alwaysVisible, children, ...props }: TableActionsCellProps) {
  return (
    <td
      {...props}
      className={clsx(
        'py-2 pr-[var(--cell-spacing)] first:pl-[var(--cell-spacing)] text-right text-sm transition',
        ROW_FOCUS_CLASSES,
        ROW_BG_CLASSES,
        ROW_BORDER_CLASSES
      )}
    >
      <div
        className={clsx(
          'flex justify-end w-full transition group-hover/tr:opacity-100 group-focus/tr:opacity-100 group-has-[:focus-visible]/tr:opacity-100 has-[[data-state="open"]]:opacity-100',
          {
            'opacity-0': !alwaysVisible,
          }
        )}
      >
        {children}
      </div>
    </td>
  )
}

TableActionsCell.displayName = 'Table.ActionsCell'
